<template>
  <v-container  grid-list-lg fill-height fluid class="pa-0">
    <v-layout align-center justify-center fill-height>
      <v-flex shrink>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import authService from "./store.js";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
export default {
  name: "authentication",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("auth", authService);
    const loginToken = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
    if (loginToken) {
      this.$router.push({ path: '/' })
    }
  },
};
</script>
